import React from 'react';
import PropTypes from 'prop-types';
import { getAllParams } from '../service/utils';

const AccessibilityButton = ({ onClick, children, ...params }) => {
  return (
    <button
      onClick={onClick}
      {...getAllParams(params)}>
      {children}
    </button>
  );
};

AccessibilityButton.propTypes = window.config.developMode ? {
  onClick: PropTypes.func.isRequired
} : {};

export default AccessibilityButton;